/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React, { useContext, useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { NavLink } from "react-router-dom";
import { checkIsActive } from "../../../../_helpers";
import { getUserInfo } from "../../../../../utils/user.util";
import "./sideMenu.scss";
import { ApiGet } from "../../../../../helpers/API/ApiData";

export function AsideMenuList({ layoutProps }) {
  const [id, setId] = useState();
  const location = useLocation();
  let userInfo = getUserInfo();

  const [isOpenKitsList, setIsOpenKitsList] = useState(false);
  const [user, setUser] = useState([]);

  const ref = useRef();

  const getMenuItemActive = (url, hasSubmenu = false) => {
    return checkIsActive(location, url)
      ? ` ${
          !hasSubmenu && "menu-item-active"
        } menu-item-open menu-item-not-hightlighted`
      : "";
  };

  const getPVBTrueUser = async () => {
    try {
      const response = await ApiGet("user/getUsersExclAdmin");
      setUser(response?.data?.payload?.users);
    } catch (error) {
      console.error("error", error);
    }
  };

  useEffect(() => {
    getPVBTrueUser();
  }, []);

  return (
    <>
      {userInfo?.role === "admin" && (
        <ul className={`menu-nav ${layoutProps.ulClasses}`} ref={ref}>
          <li
            className={`menu-item ${getMenuItemActive("/dashboard", false)}`}
            aria-haspopup="true"
          >
            <NavLink className="menu-link" to="/dashboard">
              <span className="svg-icon menu-icon">
                <svg
                  width="24"
                  height="20"
                  viewBox="0 0 24 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M19.9545 3.54469C17.8846 1.48711 15.096 0.314504 12.1777 0.274496C9.25932 0.234487 6.43965 1.33021 4.31407 3.33027C2.18849 5.33034 0.923398 8.07819 0.785934 10.9936C0.648469 13.909 1.64939 16.7637 3.57735 18.9548L3.58579 18.9642C3.60125 18.9806 3.61579 18.9975 3.63266 19.0134C3.66735 19.0528 3.70672 19.0974 3.75313 19.1438C3.93512 19.3372 4.15508 19.491 4.39925 19.5955C4.64341 19.7 4.90652 19.753 5.17211 19.7512C5.4377 19.7493 5.70005 19.6927 5.94273 19.5848C6.18542 19.4769 6.40322 19.32 6.5825 19.1241C7.27234 18.3743 8.11022 17.7759 9.04317 17.3665C9.97612 16.9571 10.9839 16.7458 12.0027 16.7458C13.0215 16.7458 14.0292 16.9571 14.9622 17.3665C15.8951 17.7759 16.733 18.3743 17.4228 19.1241C17.6034 19.3211 17.823 19.4784 18.0676 19.5861C18.3121 19.6938 18.5764 19.7496 18.8437 19.7498C19.1109 19.7501 19.3753 19.6949 19.6201 19.5876C19.8649 19.4804 20.0848 19.3235 20.2658 19.1269L20.4163 18.9628L20.4247 18.9534C22.3243 16.8084 23.3336 14.0191 23.2465 11.1552C23.1594 8.2912 21.9824 5.56847 19.9559 3.54282L19.9545 3.54469ZM11.2498 4.00173C11.2498 3.80281 11.3289 3.61205 11.4695 3.4714C11.6102 3.33074 11.8009 3.25173 11.9998 3.25173C12.1988 3.25173 12.3895 3.33074 12.5302 3.4714C12.6708 3.61205 12.7498 3.80281 12.7498 4.00173V5.50173C12.7498 5.70064 12.6708 5.8914 12.5302 6.03205C12.3895 6.17271 12.1988 6.25173 11.9998 6.25173C11.8009 6.25173 11.6102 6.17271 11.4695 6.03205C11.3289 5.8914 11.2498 5.70064 11.2498 5.50173V4.00173ZM5.99985 12.2517H4.49985C4.30094 12.2517 4.11017 12.1727 3.96952 12.0321C3.82887 11.8914 3.74985 11.7006 3.74985 11.5017C3.74985 11.3028 3.82887 11.112 3.96952 10.9714C4.11017 10.8307 4.30094 10.7517 4.49985 10.7517H5.99985C6.19876 10.7517 6.38953 10.8307 6.53018 10.9714C6.67083 11.112 6.74985 11.3028 6.74985 11.5017C6.74985 11.7006 6.67083 11.8914 6.53018 12.0321C6.38953 12.1727 6.19876 12.2517 5.99985 12.2517ZM8.28735 7.78923C8.14671 7.92977 7.95602 8.00872 7.75719 8.00872C7.55836 8.00872 7.36767 7.92977 7.22703 7.78923L6.16625 6.72891C6.02559 6.58824 5.94656 6.39746 5.94656 6.19852C5.94656 5.99959 6.02559 5.8088 6.16625 5.66813C6.30692 5.52746 6.49771 5.44844 6.69664 5.44844C6.89558 5.44844 7.08637 5.52746 7.22703 5.66813L8.28735 6.72891C8.42789 6.86955 8.50684 7.06024 8.50684 7.25907C8.50684 7.4579 8.42789 7.64859 8.28735 7.78923ZM15.2858 8.87204L13.0592 12.4111C12.9681 12.5373 12.8573 12.6481 12.7311 12.7392C12.4263 12.9518 12.05 13.0357 11.6838 12.9726C11.3176 12.9094 10.991 12.7044 10.775 12.402C10.5591 12.0996 10.471 11.7243 10.5301 11.3574C10.5891 10.9905 10.7905 10.6617 11.0905 10.4424L14.6295 8.21579C14.71 8.15971 14.8057 8.12964 14.9038 8.12964C15.0018 8.12964 15.0975 8.15971 15.178 8.21579C15.279 8.28873 15.3471 8.3987 15.3673 8.52167C15.3875 8.64464 15.3582 8.7706 15.2858 8.87204ZM16.7727 7.78923C16.6309 7.92394 16.4421 7.99793 16.2465 7.99543C16.0509 7.99293 15.8641 7.91412 15.7258 7.77582C15.5875 7.63752 15.5086 7.45066 15.5061 7.25509C15.5036 7.05952 15.5776 6.87071 15.7123 6.72891L16.7727 5.66813C16.9133 5.52746 17.1041 5.44844 17.3031 5.44844C17.502 5.44844 17.6928 5.52746 17.8334 5.66813C17.9741 5.8088 18.0531 5.99959 18.0531 6.19852C18.0531 6.39746 17.9741 6.58824 17.8334 6.72891L16.7727 7.78923ZM19.4998 12.2517H17.9998C17.8009 12.2517 17.6102 12.1727 17.4695 12.0321C17.3289 11.8914 17.2498 11.7006 17.2498 11.5017C17.2498 11.3028 17.3289 11.112 17.4695 10.9714C17.6102 10.8307 17.8009 10.7517 17.9998 10.7517H19.4998C19.6988 10.7517 19.8895 10.8307 20.0302 10.9714C20.1708 11.112 20.2498 11.3028 20.2498 11.5017C20.2498 11.7006 20.1708 11.8914 20.0302 12.0321C19.8895 12.1727 19.6988 12.2517 19.4998 12.2517Z"
                    fill="#B5B5C3"
                  />
                </svg>
              </span>
              <span className="menu-text">Dashboard</span>
            </NavLink>
          </li>
          <li
            className={`menu-item ${getMenuItemActive("/credential", false)}`}
            aria-haspopup="true"
          >
            <NavLink className="menu-link" to="/credential">
              <span className="svg-icon menu-icon">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M20.3034 3.7004C19.1121 2.50744 17.5536 1.75066 15.8794 1.55217C14.2052 1.35368 12.513 1.72507 11.0758 2.60641C9.63854 3.48775 8.54018 4.82762 7.95793 6.40981C7.37568 7.99201 7.34349 9.72423 7.86657 11.327L2.6897 16.5038C2.5498 16.6426 2.43889 16.8078 2.36341 16.9899C2.28792 17.1719 2.24938 17.3671 2.25001 17.5641V20.2538C2.25001 20.6517 2.40804 21.0332 2.68935 21.3145C2.97065 21.5958 3.35218 21.7538 3.75001 21.7538H6.75001C6.94892 21.7538 7.13969 21.6748 7.28034 21.5342C7.42099 21.3935 7.50001 21.2028 7.50001 21.0038V19.5038H9.00001C9.19892 19.5038 9.38969 19.4248 9.53034 19.2842C9.67099 19.1435 9.75001 18.9528 9.75001 18.7538V17.2538H11.25C11.3485 17.2539 11.4461 17.2346 11.5371 17.1969C11.6282 17.1593 11.7109 17.1041 11.7806 17.0345L12.6769 16.1373C13.4271 16.3813 14.2111 16.5051 15 16.5038H15.0094C16.492 16.502 17.9408 16.0609 19.1728 15.236C20.4048 14.4112 21.3646 13.2398 21.9312 11.8697C22.4977 10.4996 22.6454 8.99231 22.3557 7.53829C22.066 6.08427 21.3518 4.74873 20.3034 3.7004ZM16.875 8.62884C16.5783 8.62884 16.2883 8.54086 16.0417 8.37604C15.795 8.21122 15.6027 7.97695 15.4892 7.70286C15.3757 7.42877 15.346 7.12717 15.4038 6.8362C15.4617 6.54523 15.6046 6.27796 15.8143 6.06818C16.0241 5.8584 16.2914 5.71554 16.5824 5.65766C16.8733 5.59978 17.1749 5.62949 17.449 5.74302C17.7231 5.85655 17.9574 6.04881 18.1222 6.29548C18.287 6.54216 18.375 6.83217 18.375 7.12884C18.375 7.52666 18.217 7.90819 17.9357 8.1895C17.6544 8.4708 17.2728 8.62884 16.875 8.62884Z"
                    fill="#B5B5C3"
                  />
                </svg>
              </span>
              <span className="menu-text">Vertriebspartner</span>
            </NavLink>
          </li>
          {/* <li className={`menu-item ${getMenuItemActive("/Parkplatzbesitzer", false)}`} aria-haspopup="true">
            <NavLink className="menu-link" to="/Parkplatzbesitzer">
              <span className="svg-icon menu-icon">
              <svg width="800px" height="800px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M3 8L5.72187 10.2682C5.90158 10.418 6.12811 10.5 6.36205 10.5H17.6379C17.8719 10.5 18.0984 10.418 18.2781 10.2682L21 8M6.5 14H6.51M17.5 14H17.51M8.16065 4.5H15.8394C16.5571 4.5 17.2198 4.88457 17.5758 5.50772L20.473 10.5777C20.8183 11.1821 21 11.8661 21 12.5623V18.5C21 19.0523 20.5523 19.5 20 19.5H19C18.4477 19.5 18 19.0523 18 18.5V17.5H6V18.5C6 19.0523 5.55228 19.5 5 19.5H4C3.44772 19.5 3 19.0523 3 18.5V12.5623C3 11.8661 3.18166 11.1821 3.52703 10.5777L6.42416 5.50772C6.78024 4.88457 7.44293 4.5 8.16065 4.5ZM7 14C7 14.2761 6.77614 14.5 6.5 14.5C6.22386 14.5 6 14.2761 6 14C6 13.7239 6.22386 13.5 6.5 13.5C6.77614 13.5 7 13.7239 7 14ZM18 14C18 14.2761 17.7761 14.5 17.5 14.5C17.2239 14.5 17 14.2761 17 14C17 13.7239 17.2239 13.5 17.5 13.5C17.7761 13.5 18 13.7239 18 14Z"
                      stroke="#B5B5C3"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
              </span>
              <span className="menu-text">Parkplatzbesitzer</span>
            </NavLink>
          </li> */}

          <li
            className={`menu-item ${getMenuItemActive("/vattenfall", false)}`}
            onMouseEnter={() => setId(2)}
            onMouseLeave={() => setId("")}
            aria-haspopup="true"
          >
            <NavLink className="menu-link" to="/vattenfall">
              <span className="svg-icon menu-icon">
                {getMenuItemActive("/vattenfall") || id == "2" ? (
                  <svg
                    width="800px"
                    height="800px"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M3 8L5.72187 10.2682C5.90158 10.418 6.12811 10.5 6.36205 10.5H17.6379C17.8719 10.5 18.0984 10.418 18.2781 10.2682L21 8M6.5 14H6.51M17.5 14H17.51M8.16065 4.5H15.8394C16.5571 4.5 17.2198 4.88457 17.5758 5.50772L20.473 10.5777C20.8183 11.1821 21 11.8661 21 12.5623V18.5C21 19.0523 20.5523 19.5 20 19.5H19C18.4477 19.5 18 19.0523 18 18.5V17.5H6V18.5C6 19.0523 5.55228 19.5 5 19.5H4C3.44772 19.5 3 19.0523 3 18.5V12.5623C3 11.8661 3.18166 11.1821 3.52703 10.5777L6.42416 5.50772C6.78024 4.88457 7.44293 4.5 8.16065 4.5ZM7 14C7 14.2761 6.77614 14.5 6.5 14.5C6.22386 14.5 6 14.2761 6 14C6 13.7239 6.22386 13.5 6.5 13.5C6.77614 13.5 7 13.7239 7 14ZM18 14C18 14.2761 17.7761 14.5 17.5 14.5C17.2239 14.5 17 14.2761 17 14C17 13.7239 17.2239 13.5 17.5 13.5C17.7761 13.5 18 13.7239 18 14Z"
                      stroke="#B5B5C3"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                ) : (
                  <svg
                    width="800px"
                    height="800px"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M3 8L5.72187 10.2682C5.90158 10.418 6.12811 10.5 6.36205 10.5H17.6379C17.8719 10.5 18.0984 10.418 18.2781 10.2682L21 8M6.5 14H6.51M17.5 14H17.51M8.16065 4.5H15.8394C16.5571 4.5 17.2198 4.88457 17.5758 5.50772L20.473 10.5777C20.8183 11.1821 21 11.8661 21 12.5623V18.5C21 19.0523 20.5523 19.5 20 19.5H19C18.4477 19.5 18 19.0523 18 18.5V17.5H6V18.5C6 19.0523 5.55228 19.5 5 19.5H4C3.44772 19.5 3 19.0523 3 18.5V12.5623C3 11.8661 3.18166 11.1821 3.52703 10.5777L6.42416 5.50772C6.78024 4.88457 7.44293 4.5 8.16065 4.5ZM7 14C7 14.2761 6.77614 14.5 6.5 14.5C6.22386 14.5 6 14.2761 6 14C6 13.7239 6.22386 13.5 6.5 13.5C6.77614 13.5 7 13.7239 7 14ZM18 14C18 14.2761 17.7761 14.5 17.5 14.5C17.2239 14.5 17 14.2761 17 14C17 13.7239 17.2239 13.5 17.5 13.5C17.7761 13.5 18 13.7239 18 14Z"
                      stroke="#B5B5C3"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                )}
              </span>
              <span className="menu-text">Leads</span>
            </NavLink>
          </li>

          <li
            className={`menu-item  ${getMenuItemActive("/news", false)}`}
            aria-haspopup="true"
          >
            <NavLink className="menu-link " to="/news">
              <span className="svg-icon menu-icon">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M5.99709 14.4016V12.0016H8.39709V14.4016H5.99709ZM17.9971 5.39436C17.9952 4.91822 17.8047 4.46223 17.4673 4.12622C17.13 3.79021 16.6732 3.60156 16.1971 3.60156H4.10469C3.6273 3.60156 3.16946 3.7912 2.8319 4.12877C2.49433 4.46634 2.30469 4.92417 2.30469 5.40156V16.2016C2.30469 16.9972 2.62076 17.7603 3.18337 18.3229C3.74598 18.8855 4.50904 19.2016 5.30469 19.2016H18.6895C19.4851 19.2016 20.2482 18.8855 20.8108 18.3229C21.3734 17.7603 21.6895 16.9972 21.6895 16.2016V9.00156C21.6895 8.52417 21.4998 8.06634 21.1623 7.72877C20.8247 7.3912 20.3669 7.20156 19.8895 7.20156H19.1971V15.8776C19.1971 16.0367 19.1339 16.1893 19.0214 16.3018C18.9088 16.4143 18.7562 16.4776 18.5971 16.4776C18.438 16.4776 18.2853 16.4143 18.1728 16.3018C18.0603 16.1893 17.9971 16.0367 17.9971 15.8776V5.39436ZM4.79709 7.80156C4.79709 7.64243 4.8603 7.48982 4.97282 7.3773C5.08535 7.26478 5.23796 7.20156 5.39709 7.20156H14.9971C15.1562 7.20156 15.3088 7.26478 15.4214 7.3773C15.5339 7.48982 15.5971 7.64243 15.5971 7.80156C15.5971 7.96069 15.5339 8.1133 15.4214 8.22583C15.3088 8.33835 15.1562 8.40156 14.9971 8.40156H5.39709C5.23796 8.40156 5.08535 8.33835 4.97282 8.22583C4.8603 8.1133 4.79709 7.96069 4.79709 7.80156ZM11.3971 10.8016H14.9971C15.1562 10.8016 15.3088 10.8648 15.4214 10.9773C15.5339 11.0898 15.5971 11.2424 15.5971 11.4016C15.5971 11.5607 15.5339 11.7133 15.4214 11.8258C15.3088 11.9383 15.1562 12.0016 14.9971 12.0016H11.3971C11.238 12.0016 11.0853 11.9383 10.9728 11.8258C10.8603 11.7133 10.7971 11.5607 10.7971 11.4016C10.7971 11.2424 10.8603 11.0898 10.9728 10.9773C11.0853 10.8648 11.238 10.8016 11.3971 10.8016ZM10.7971 15.0016C10.7971 14.8424 10.8603 14.6898 10.9728 14.5773C11.0853 14.4648 11.238 14.4016 11.3971 14.4016H14.9971C15.1562 14.4016 15.3088 14.4648 15.4214 14.5773C15.5339 14.6898 15.5971 14.8424 15.5971 15.0016C15.5971 15.1607 15.5339 15.3133 15.4214 15.4258C15.3088 15.5383 15.1562 15.6016 14.9971 15.6016H11.3971C11.238 15.6016 11.0853 15.5383 10.9728 15.4258C10.8603 15.3133 10.7971 15.1607 10.7971 15.0016ZM5.39709 10.8016H8.99709C9.15622 10.8016 9.30883 10.8648 9.42135 10.9773C9.53387 11.0898 9.59709 11.2424 9.59709 11.4016V15.0016C9.59709 15.1607 9.53387 15.3133 9.42135 15.4258C9.30883 15.5383 9.15622 15.6016 8.99709 15.6016H5.39709C5.23796 15.6016 5.08535 15.5383 4.97282 15.4258C4.8603 15.3133 4.79709 15.1607 4.79709 15.0016V11.4016C4.79709 11.2424 4.8603 11.0898 4.97282 10.9773C5.08535 10.8648 5.23796 10.8016 5.39709 10.8016Z"
                    fill="#B5B5C3"
                  />
                </svg>
              </span>
              <span className="menu-text">Newsletter (Website)</span>
            </NavLink>
          </li>

          <li
            className={`menu-item ${getMenuItemActive("/contact-us", false)}`}
            onMouseEnter={() => setId(3)}
            onMouseLeave={() => setId("")}
            aria-haspopup="true"
          >
            <NavLink className="menu-link" to="/contact-us">
              <span className="svg-icon menu-icon">
                {getMenuItemActive("/contact-us") || id == "3" ? (
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                    <path
                      fill="#bbbbc8"
                      d="M384 48c8.8 0 16 7.2 16 16l0 384c0 8.8-7.2 16-16 16L96 464c-8.8 0-16-7.2-16-16L80 64c0-8.8 7.2-16 16-16l288 0zM96 0C60.7 0 32 28.7 32 64l0 384c0 35.3 28.7 64 64 64l288 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L96 0zM240 256a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-32 32c-44.2 0-80 35.8-80 80c0 8.8 7.2 16 16 16l192 0c8.8 0 16-7.2 16-16c0-44.2-35.8-80-80-80l-64 0zM512 80c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64zM496 192c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64c0-8.8-7.2-16-16-16zm16 144c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64z"
                    />
                  </svg>
                ) : (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="800px"
                    height="24px"
                    viewBox="0 0 512 512"
                  >
                    <path
                      fill="#bbbbc8"
                      d="M384 48c8.8 0 16 7.2 16 16l0 384c0 8.8-7.2 16-16 16L96 464c-8.8 0-16-7.2-16-16L80 64c0-8.8 7.2-16 16-16l288 0zM96 0C60.7 0 32 28.7 32 64l0 384c0 35.3 28.7 64 64 64l288 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L96 0zM240 256a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-32 32c-44.2 0-80 35.8-80 80c0 8.8 7.2 16 16 16l192 0c8.8 0 16-7.2 16-16c0-44.2-35.8-80-80-80l-64 0zM512 80c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64zM496 192c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64c0-8.8-7.2-16-16-16zm16 144c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64z"
                    />
                  </svg>
                )}
              </span>
              <span className="menu-text">Kontakt (Website)</span>
            </NavLink>
          </li>

          <li
            className={`menu-item`}
            onClick={() => setIsOpenKitsList(!isOpenKitsList)}
            aria-haspopup="true"
          >
            <div className="menu-link">
              <span className="svg-icon menu-icon">
                <svg
                  width="16"
                  height="18"
                  viewBox="0 0 16 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0.777477 12.5885H7.16914V10.0885H2.66914C1.88581 10.0885 1.21081 10.6302 1.04414 11.3969L0.777477 12.5885ZM8.83581 12.5885H15.2275L14.9608 11.3969C14.8779 11.0271 14.672 10.6965 14.3769 10.4588C14.0817 10.2212 13.7147 10.0907 13.3358 10.0885H8.83581V12.5885ZM15.5941 14.2552H8.83581V17.5885H14.2608C15.3275 17.5885 16.1191 16.6052 15.8858 15.5635L15.5941 14.2552ZM1.74414 17.5885H7.16914V14.2552H0.410811L0.119144 15.5635C-0.11419 16.6052 0.677477 17.5885 1.74414 17.5885ZM8.00248 5.92188C7.54414 5.92188 7.16914 6.29688 7.16914 6.75521V7.58854C7.16914 8.04688 7.54414 8.42188 8.00248 8.42188C8.46081 8.42188 8.83581 8.04688 8.83581 7.58854V6.75521C8.83581 6.29688 8.46081 5.92188 8.00248 5.92188ZM13.4941 6.43854C13.5714 6.36145 13.6327 6.26987 13.6745 6.16906C13.7163 6.06825 13.7378 5.96018 13.7378 5.85104C13.7378 5.7419 13.7163 5.63383 13.6745 5.53302C13.6327 5.43221 13.5714 5.34064 13.4941 5.26354L12.9025 4.67188C12.8253 4.59472 12.7337 4.53352 12.6329 4.49177C12.5321 4.45002 12.4241 4.42852 12.315 4.42852C12.2059 4.42852 12.0978 4.45002 11.997 4.49177C11.8962 4.53352 11.8046 4.59472 11.7275 4.67188C11.6503 4.74903 11.5891 4.84062 11.5474 4.94142C11.5056 5.04223 11.4841 5.15027 11.4841 5.25937C11.4841 5.36848 11.5056 5.47652 11.5474 5.57733C11.5891 5.67813 11.6503 5.76972 11.7275 5.84687L12.3191 6.43854C12.6441 6.76354 13.1691 6.76354 13.4941 6.43854ZM3.68581 6.43854L4.27748 5.84687C4.35463 5.76972 4.41583 5.67813 4.45758 5.57733C4.49934 5.47652 4.52083 5.36848 4.52083 5.25937C4.52083 5.15027 4.49934 5.04223 4.45758 4.94142C4.41583 4.84062 4.35463 4.74903 4.27748 4.67188C4.20033 4.59472 4.10873 4.53352 4.00793 4.49177C3.90713 4.45002 3.79909 4.42852 3.68998 4.42852C3.58087 4.42852 3.47283 4.45002 3.37202 4.49177C3.27122 4.53352 3.17963 4.59472 3.10248 4.67188L2.51081 5.25521C2.43356 5.3323 2.37227 5.42388 2.33045 5.52469C2.28863 5.6255 2.26711 5.73357 2.26711 5.84271C2.26711 5.95185 2.28863 6.05992 2.33045 6.16073C2.37227 6.26154 2.43356 6.35311 2.51081 6.43021C2.83581 6.76354 3.36081 6.76354 3.68581 6.43854ZM2.16914 0.921875H1.33581C0.877477 0.921875 0.502477 1.29687 0.502477 1.75521C0.502477 2.21354 0.877477 2.58854 1.33581 2.58854H2.16914C2.62748 2.58854 3.00248 2.21354 3.00248 1.75521C3.00248 1.29687 2.62748 0.921875 2.16914 0.921875ZM14.6691 0.921875H13.8358C13.3775 0.921875 13.0025 1.29687 13.0025 1.75521C13.0025 2.21354 13.3775 2.58854 13.8358 2.58854H14.6691C15.1275 2.58854 15.5025 2.21354 15.5025 1.75521C15.5025 1.29687 15.1275 0.921875 14.6691 0.921875ZM8.00248 5.08854C10.3025 5.08854 12.1691 3.22187 12.1691 0.921875H3.83581C3.83581 3.22187 5.70248 5.08854 8.00248 5.08854Z"
                    fill="#9F9F9F"
                  />
                </svg>
              </span>
              <span className="menu-text">Unzer Verkauf</span>
              <span className="svg-icon menu-icon">
                {!isOpenKitsList ? (
                  <>
                    <svg
                      fill="#000000"
                      width="22px"
                      height="22px"
                      viewBox="-8.5 0 32 32"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <title>angle-down</title>
                      <path
                        fill="#B5B5C3"
                        d="M7.28 20.040c-0.24 0-0.44-0.080-0.6-0.24l-6.44-6.44c-0.32-0.32-0.32-0.84 0-1.2 0.32-0.32 0.84-0.32 1.2 0l5.84 5.84 5.84-5.84c0.32-0.32 0.84-0.32 1.2 0 0.32 0.32 0.32 0.84 0 1.2l-6.44 6.44c-0.16 0.16-0.4 0.24-0.6 0.24z"
                      ></path>
                    </svg>
                  </>
                ) : (
                  <svg
                    width="22px"
                    height="22px"
                    viewBox="0 0 32 32"
                    version="1.1"
                  >
                    <g id="icomoon-ignore"></g>
                    <path
                      d="M16.767 12.809l-0.754-0.754-6.035 6.035 0.754 0.754 5.281-5.281 5.256 5.256 0.754-0.754-3.013-3.013z"
                      fill="#B5B5C3"
                    ></path>
                  </svg>
                )}
              </span>
            </div>
          </li>

          {isOpenKitsList && (
            <>
              {user
                ?.sort((a, b) => a?.name.localeCompare(b?.name))
                .map((item, index) => {
                  return (
                    <li
                      key={index}
                      className={`menu-item  ${getMenuItemActive(
                        `/projekte-trello?id=${item?._id}`,
                        false
                      )}`}
                      aria-haspopup="true"
                    >
                      <NavLink
                        className="menu-link "
                        to={`/projekte-trello?id=${item?._id}`}
                        style={{ paddingLeft: "40px" }}
                      >
                        <span className="svg-icon menu-icon">
                          <i className="fas fa-user-check"></i>
                        </span>
                        <span className="menu-text">{item?.name}</span>
                      </NavLink>
                    </li>
                  );
                })}
            </>
          )}

          <li
            className={`menu-item  ${getMenuItemActive(
              "/mitteilungen",
              false
            )}`}
            aria-haspopup="true"
          >
            <NavLink className="menu-link " to="/mitteilungen">
              <span className="svg-icon menu-icon">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M19.6636 15.4276C19.5945 15.3473 19.5267 15.2669 19.4601 15.1894C18.5442 14.1202 17.9901 13.475 17.9901 10.4483C17.9901 8.88134 17.6016 7.59562 16.836 6.63134C16.2715 5.91897 15.5084 5.37857 14.5026 4.9792C14.4896 4.97225 14.4781 4.96313 14.4684 4.95228C14.1067 3.78308 13.1167 3 12.0001 3C10.8835 3 9.89396 3.78308 9.53218 4.95107C9.52255 4.96154 9.51115 4.97037 9.49846 4.97719C7.15128 5.90973 6.01057 7.69888 6.01057 10.4471C6.01057 13.475 5.45729 14.1202 4.54056 15.1882C4.47395 15.2657 4.40609 15.3445 4.33698 15.4264C4.15847 15.6342 4.04536 15.887 4.01106 16.1549C3.97675 16.4227 4.02267 16.6945 4.1434 16.9379C4.40026 17.4603 4.94772 17.7845 5.57261 17.7845H18.4322C19.0542 17.7845 19.5979 17.4607 19.8556 16.9408C19.9768 16.6972 20.0232 16.4253 19.9892 16.1571C19.9551 15.8889 19.8422 15.6357 19.6636 15.4276ZM12.0001 21C12.6017 20.9995 13.1919 20.8419 13.7082 20.5439C14.2245 20.2459 14.6476 19.8186 14.9326 19.3073C14.9461 19.2828 14.9527 19.2553 14.9519 19.2276C14.9511 19.1999 14.9429 19.1729 14.928 19.1491C14.9132 19.1254 14.8922 19.1058 14.8672 19.0922C14.8422 19.0785 14.814 19.0714 14.7853 19.0714H9.21579C9.18703 19.0713 9.15874 19.0784 9.13366 19.092C9.10859 19.1056 9.08759 19.1252 9.07271 19.149C9.05783 19.1727 9.04957 19.1998 9.04874 19.2275C9.04792 19.2553 9.05455 19.2827 9.06799 19.3073C9.35298 19.8185 9.776 20.2458 10.2922 20.5438C10.8084 20.8418 11.3986 20.9995 12.0001 21Z"
                    fill="#B5B5C3"
                  />
                </svg>
              </span>
              <span className="menu-text">Mitteilungen</span>
            </NavLink>
          </li>

          <li
            className={`menu-item  ${getMenuItemActive("/google-map", false)}`}
            aria-haspopup="true"
          >
            <NavLink className="menu-link " to="/google-map">
              <span className="svg-icon menu-icon">
                <svg
                  fill="#B5B5C3"
                  height="20px"
                  width="20px"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                >
                  <g id="map-location">
                    <path
                      class="st0"
                      d="M18.3,4.4C17.4,1.8,14.9,0,12,0C8.8,0,6.1,2.3,5.4,5.3L0,3v17.2l8,3.4l8-3l8,3.4V6.8L18.3,4.4z M9,14.4
		c1.2,1.4,2.3,2.2,2.4,2.3l0.7,0.6l0.6-0.6c0.3-0.3,0.7-0.7,1.1-1c0.4-0.4,0.8-0.8,1.2-1.2v4.3l-6,2.3V14.4z M12,2
		c2.6,0,4.8,2.1,4.8,4.8c0,1.9-0.8,3.4-1.8,4.7l0,0l0,0c-0.8,1-1.7,1.9-2.6,2.7c-0.1,0.1-0.3,0.3-0.4,0.4c-1.8-1.6-4.8-5-4.8-7.8
		C7.2,4.1,9.4,2,12,2z M2,6l3.3,1.4c0.2,1.5,0.9,3,1.7,4.4V21l-5-2.1V6z M22,21l-5-2.1v-6.7c1-1.5,1.8-3.2,1.8-5.4L22,8.2V21z"
                    />
                    <circle class="st0" cx="12" cy="7" r="2" />
                  </g>
                </svg>
              </span>
              <span className="menu-text">Heatmap</span>
            </NavLink>
          </li>

          {/* <li className={`menu-item  ${getMenuItemActive("/locations", false)}`} aria-haspopup="true">
            <NavLink className="menu-link " to="/locations">
              <span className="svg-icon menu-icon">
                <svg width="800px" height="800px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M12 2c-4.4 0-8 3.6-8 8 0 5.4 7 11.5 7.3 11.8.2.1.5.2.7.2.2 0 .5-.1.7-.2.3-.3 7.3-6.4 7.3-11.8 0-4.4-3.6-8-8-8zm0 17.7c-2.1-2-6-6.3-6-9.7 0-3.3 2.7-6 6-6s6 2.7 6 6-3.9 7.7-6 9.7zM12 6c-2.2 0-4 1.8-4 4s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
                    fill="#b5b5c3"
                  />
                </svg>
              </span>
              <span className="menu-text">Standorte</span>
            </NavLink>
          </li> */}

          {/* <li className={`menu-item  ${getMenuItemActive("/events", false)}`} aria-haspopup="true">
            <NavLink className="menu-link " to="/events">
              <span className="svg-icon menu-icon">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
                  <path d="M0 128C0 92.7 28.7 64 64 64l256 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 128zM559.1 99.8c10.4 5.6 16.9 16.4 16.9 28.2l0 256c0 11.8-6.5 22.6-16.9 28.2s-23 5-32.9-1.6l-96-64L416 337.1l0-17.1 0-128 0-17.1 14.2-9.5 96-64c9.8-6.5 22.4-7.2 32.9-1.6z" 
                  fill="#b5b5c3"
                  />
                </svg>
              </span>
              <span className="menu-text">Alle Parkevents</span>
            </NavLink>
          </li> */}

          {/* 
          <li
            className={`menu-item ${getMenuItemActive("/stepper", false)}`}
            aria-haspopup="true"
            onMouseEnter={() => setId(1)}
            onMouseLeave={() => setId("")}
          >
            <NavLink className="menu-link" to="/stepper">
              <span className="svg-icon menu-icon">
                {getMenuItemActive("/stepper") || id == "1" ? (
                  <svg
                    width="15"
                    height="15"
                    viewBox="0 0 270 228"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M52.7207 227.986C51.2107 226.076 48.7207 226.156 46.7207 225.136C40.431 221.967 35.5933 216.51 33.2007 209.886C31.8364 206.193 31.1586 202.282 31.2007 198.346C31.2407 174.106 31.2407 149.859 31.2007 125.606C31.3613 124.424 31.2096 123.221 30.7607 122.116H20.5507C16.8907 122.116 13.2207 122.116 9.5507 122.056C4.6907 121.986 0.640703 117.786 0.100703 112.986C-0.459297 107.986 1.3107 104.486 5.5507 101.696C8.8807 99.5158 11.6907 96.5658 14.7807 94.0058C23.694 86.6591 32.6174 79.3191 41.5507 71.9858C41.9107 71.6858 42.2907 71.3958 42.7207 71.0558C43.086 71.2218 43.4022 71.4794 43.6387 71.8035C43.8752 72.1276 44.024 72.5073 44.0707 72.9058C44.3107 77.4358 45.8007 81.7258 46.3707 86.2058C46.8607 90.0458 48.1107 93.7858 48.9607 97.5858C49.3807 99.4958 49.6907 101.446 49.9607 103.356C51.1207 110.356 52.9607 117.216 54.3807 124.146C55.5607 129.776 56.8207 135.416 58.3807 140.956C59.9407 146.496 61.4607 152.186 62.9507 157.806C64.3807 163.206 65.8107 168.626 67.4307 173.956C69.5107 180.796 71.3107 187.746 73.9907 194.416C75.0407 197.036 75.6607 199.826 76.5607 202.796H97.8907C111.001 169.616 124.001 136.346 134.781 102.086C145.521 136.206 158.511 169.456 171.701 202.866H192.761C207.851 159.776 217.571 115.516 226.151 70.4258L243.771 84.9858C251.001 90.9858 258.151 97.0658 265.511 102.886C266.766 103.888 267.806 105.133 268.568 106.548C269.329 107.962 269.796 109.516 269.941 111.116C269.161 113.836 268.941 117.026 266.291 119.336C264.451 120.956 262.581 122.106 260.061 122.096C253.811 122.096 247.561 122.096 241.311 122.096H238.701C237.931 123.266 238.201 124.376 238.201 125.426C238.201 149.926 238.201 174.422 238.201 198.916C238.201 207.916 235.131 215.486 228.261 221.416C225.257 224.091 221.651 226.002 217.751 226.986C217.041 227.156 216.491 227.306 216.221 227.986H52.7207Z"
                      fill="#F6AC0F"
                    />
                    <path
                      d="M143.757 71.1542H125.927C120.727 88.5742 115.217 106.294 109.017 123.774C102.817 141.254 96.2969 158.474 89.8269 175.984C87.7269 174.464 88.0069 171.984 87.2869 169.984C86.1669 166.884 85.6169 163.604 84.6169 160.454C83.6169 157.304 82.9969 153.984 82.2569 150.754C81.4469 146.954 80.3869 143.224 79.5569 139.444C78.8069 136.034 78.0669 132.614 77.2569 129.214C76.2569 125.034 75.5769 120.794 74.4569 116.624C73.4569 112.944 73.0469 109.104 72.1869 105.374C71.1869 101.104 70.7569 96.7242 69.4769 92.5142C68.9169 90.6442 68.9069 88.6642 68.4769 86.7342C67.3969 82.3942 67.1969 77.8242 66.1169 73.4842C65.0369 69.1442 64.8269 64.6242 63.4469 60.3442C62.9469 58.7942 63.6269 57.0142 62.5469 55.4042C64.0169 52.9042 66.4869 51.3442 68.6269 49.5142C73.8069 45.0742 79.1069 40.7842 84.3869 36.4642C92.8869 29.5342 101.387 22.6542 109.907 15.6842C114.387 11.9842 118.707 7.98423 123.307 4.33423C130.107 -1.07577 138.417 -1.66577 145.507 3.95423C155.067 11.5742 164.507 19.3442 173.927 27.1442C184.557 35.9842 195.107 44.8642 205.697 53.7242C206.117 54.0742 206.827 54.0642 206.897 54.3442C206.237 60.4042 204.997 65.9842 203.997 71.5642C202.897 77.3742 201.717 83.2042 200.547 89.0042C199.677 93.3042 198.787 97.6542 198.107 102.004C197.517 105.834 196.187 109.544 195.547 113.364C194.957 116.904 194.057 120.364 193.317 123.874C192.437 128.074 191.567 132.264 190.457 136.414C189.537 139.874 189.027 143.414 188.197 146.924C187.367 150.434 186.267 153.754 185.557 157.214C184.917 160.324 184.067 163.364 183.257 166.414C182.527 169.144 181.867 171.894 181.087 174.604C180.986 174.908 180.801 175.178 180.553 175.381C180.305 175.585 180.005 175.714 179.687 175.754C166.807 141.234 153.777 106.824 143.757 71.1542Z"
                      fill="#135996"
                    />
                  </svg>
                ) : (
                  <svg
                    width="15"
                    height="15"
                    viewBox="0 0 76 64"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M39.4626 0.724971C39.9932 1.01742 43.4817 3.97099 43.9247 4.35044C42.4136 4.43874 37.5954 1.77359 36.173 1.81146C35.8524 1.82 35.461 1.94637 35.2319 2.15806C33.9205 3.37007 32.69 4.67125 31.3511 5.85087C29.9974 7.0435 28.5367 8.11455 27.1468 9.26744C25.9205 10.2846 24.756 11.377 23.5111 12.3701C22.2714 13.359 20.8663 14.1625 19.7302 15.251C19.1487 15.8081 18.6262 16.8555 18.7175 17.6037C19.0355 20.2125 19.5917 22.7961 20.1327 25.3735C21.3653 31.2457 22.6024 37.1176 23.9266 42.9697C24.3112 44.6694 24.9969 46.3015 25.5446 47.9646C25.4152 48.4742 25.2857 48.9837 25.1563 49.4933C25.062 49.5053 24.9678 49.5173 24.8736 49.5293C24.3534 47.6415 23.7592 45.7703 23.3263 43.8627C21.8332 37.2837 20.3729 30.697 18.9503 24.1025C18.4097 21.5967 17.9594 19.0684 17.58 16.5337C17.5095 16.0631 17.8357 15.3531 18.215 15.0254C20.6135 12.9532 23.0744 10.9527 25.5225 8.9379C28.3543 6.60719 31.1869 4.27737 34.036 1.96771C34.6453 1.47375 35.3266 1.06802 35.9818 0.521504C36.5343 0.15905 37.0685 -0.0754383 37.7893 0.0222632C38.51 0.119965 39.1837 0.571261 39.4626 0.724971Z"
                      fill="#B5B5C3"
                    />
                    <path
                      d="M0.00612782 29.7681C3.98701 26.4927 7.9679 23.2173 12.106 19.8125C12.5527 21.9537 12.964 23.9573 13.3895 25.9579C14.2268 29.8957 14.9158 33.8733 15.9499 37.759C17.5741 43.8618 19.4585 49.895 21.1653 55.9766C21.422 56.8914 21.8469 57.1275 22.6935 57.0638C23.4327 57.0082 24.1793 57.0522 24.9226 57.0522C27.1742 57.0522 27.1291 57.0359 27.9104 54.8688C31.0012 46.2949 34.1224 37.7319 37.2365 29.1663C37.2975 28.9985 37.4097 28.8492 37.5995 28.5101C38.1986 30.2721 38.7225 31.918 39.3154 33.5386C42.0438 40.9957 44.7982 48.4433 47.5231 55.9016C47.8506 56.7978 48.3571 57.1892 49.3444 57.0722C50.169 56.9746 51.0292 56.9531 51.8472 57.075C53.1311 57.2664 53.6788 56.7355 54.0689 55.5459C56.9586 46.7343 59.3438 37.7953 61.098 28.6873C61.6541 25.7997 62.2941 22.9284 62.9325 19.8734C64.0489 20.7491 65.1509 21.5882 66.2252 22.4616C68.7742 24.5339 71.2937 26.6428 73.8581 28.6957C75.105 29.6939 75.6779 31.1369 75.2145 32.4568C74.6843 33.9668 73.5629 34.7359 71.8655 34.7405C70.1032 34.7454 68.3409 34.7416 66.3806 34.7416C66.3806 35.2784 66.3806 35.7669 66.3806 36.2554C66.3806 42.9916 66.3518 49.728 66.3932 56.4639C66.4127 59.6375 64.9224 61.811 62.2376 63.3046C61.9672 63.455 61.7327 63.67 61.5605 63.9396C45.6445 64.0243 29.6494 64.0243 13.5218 63.9213C13.2014 63.6522 13.0368 63.4437 12.8222 63.3263C10.0039 61.7853 8.62414 59.4392 8.64133 56.205C8.67667 49.56 8.65195 42.9145 8.65195 36.2693C8.65195 35.7793 8.65195 35.2894 8.65195 34.7416C6.79489 34.7416 5.12417 34.6898 3.45825 34.757C1.95277 34.8177 0.819752 34.2714 0.000496588 32.9109C-0.00137387 31.7892 0.00237685 30.7786 0.00612782 29.7681Z"
                      fill="#DBDBE9"
                    />
                    <path
                      d="M25.4159 48.3693C24.7788 46.7372 24.085 45.0806 23.6958 43.3552C22.3558 37.4149 21.1039 31.4545 19.8567 25.4938C19.3092 22.8775 18.7464 20.255 18.4246 17.6069C18.3323 16.8474 18.8609 15.7842 19.4494 15.2187C20.5991 14.1138 22.0208 13.2981 23.2753 12.2944C24.535 11.2863 25.7134 10.1774 26.9543 9.14496C28.3608 7.9747 29.8388 6.8875 31.2086 5.67689C32.5635 4.47949 33.8086 3.1587 35.1356 1.92842C35.3674 1.71354 35.7635 1.58526 36.088 1.57659C37.5273 1.53816 39.4234 1.97835 40.997 1.97402C44.4634 4.71405 47.3361 7.04313 50.6767 9.77704C52.4873 11.2587 54.2449 12.8221 56.1651 14.1476C57.7925 15.2711 57.6984 16.6688 57.3529 18.2569C55.2152 28.0805 53.09 37.907 50.9377 47.7275C50.767 48.5068 50.4226 49.2481 49.8143 50.0155C46.9003 41.5873 43.9822 33.1606 41.0785 24.7289C40.7809 23.8646 40.5869 22.9652 40.3147 22.0915C39.7027 20.127 39.4981 20.0201 37.3294 20.2012C36.6433 20.2585 35.9484 20.2101 35.5263 20.2101C32.1375 29.7074 28.8181 39.0104 25.4159 48.3693Z"
                      fill="#B5B5C3"
                    />
                  </svg>
                )}
              </span>
              <span className="menu-text">WattFox Leads</span>
            </NavLink>
          </li>

          <li
            className={`menu-item ${getMenuItemActive(
              "/vattenfallmesse",
              false
            )}`}
            onMouseEnter={() => setId(20)}
            onMouseLeave={() => setId("")}
            aria-haspopup="true"
          >
            <NavLink className="menu-link" to="/vattenfallmesse">
              <span className="svg-icon menu-icon">
                {getMenuItemActive("/vattenfallmesse") || id == "20" ? (
                  <svg
                    width="228"
                    height="230"
                    viewBox="0 0 228 230"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M113.689 0C50.9003 0 0 51.4871 0 115H227.379C227.379 51.4871 176.478 0 113.689 0Z"
                      fill="#F7D307"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M113.689 230C50.9003 230 0 178.513 0 115H227.379C227.379 178.513 176.478 230 113.689 230Z"
                      fill="#1E6EB0"
                    />
                  </svg>
                ) : (
                  <svg
                    width="74"
                    height="75"
                    viewBox="0 0 74 75"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M37 0C16.5654 0 0 17.0131 0 38H74C74 17.0131 57.4346 0 37 0Z"
                      fill="#DBDBE9"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M37 75C16.5654 75 0 58.4346 0 38H74C74 58.4346 57.4346 75 37 75Z"
                      fill="#B5B5C3"
                    />
                  </svg>
                )}
              </span>
              <span className="menu-text">Vattenfall Messe Leads</span>
            </NavLink>
          </li>

          <li
            className={`menu-item ${getMenuItemActive("/vattenfallpromo", false)}`}
            onMouseEnter={() => setId(56)}
            onMouseLeave={() => setId("")}
            aria-haspopup="true"
          >
            <NavLink className="menu-link" to="/vattenfallpromo">
              <span className="svg-icon menu-icon">
                {getMenuItemActive("/vattenfallpromo") || id == "56" ? (
                  <svg
                    width="228"
                    height="230"
                    viewBox="0 0 228 230"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M113.689 0C50.9003 0 0 51.4871 0 115H227.379C227.379 51.4871 176.478 0 113.689 0Z"
                      fill="#F7D307"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M113.689 230C50.9003 230 0 178.513 0 115H227.379C227.379 178.513 176.478 230 113.689 230Z"
                      fill="#1E6EB0"
                    />
                  </svg>
                ) : (
                  <svg
                    width="74"
                    height="75"
                    viewBox="0 0 74 75"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M37 0C16.5654 0 0 17.0131 0 38H74C74 17.0131 57.4346 0 37 0Z"
                      fill="#DBDBE9"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M37 75C16.5654 75 0 58.4346 0 38H74C74 58.4346 57.4346 75 37 75Z"
                      fill="#B5B5C3"
                    />
                  </svg>
                )}
              </span>
              <span className="menu-text">Vattenfall Promo Funnel</span>
            </NavLink>
          </li>

          <li
            className={`menu-item ${getMenuItemActive("/project", false)}`}
            aria-haspopup="true"
          >
            <NavLink className="menu-link" to="/project">
              <span className="svg-icon menu-icon">
                <svg
                  width="20"
                  height="16"
                  viewBox="0 0 20 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0 1.71429C0 0.767857 0.746528 0 1.66667 0H5C5.92014 0 6.66667 0.767857 6.66667 1.71429V2.28571H13.3333V1.71429C13.3333 0.767857 14.0799 0 15 0H18.3333C19.2535 0 20 0.767857 20 1.71429V5.14286C20 6.08929 19.2535 6.85714 18.3333 6.85714H15C14.0799 6.85714 13.3333 6.08929 13.3333 5.14286V4.57143H6.66667V5.14286C6.66667 5.20357 6.66319 5.26429 6.65625 5.32143L9.44444 9.14286H12.7778C13.6979 9.14286 14.4444 9.91072 14.4444 10.8571V14.2857C14.4444 15.2321 13.6979 16 12.7778 16H9.44444C8.52431 16 7.77778 15.2321 7.77778 14.2857V10.8571C7.77778 10.7964 7.78125 10.7357 7.7882 10.6786L5 6.85714H1.66667C0.746528 6.85714 0 6.08929 0 5.14286V1.71429Z"
                    fill="#B5B5C3"
                  />
                </svg>
              </span>
              <span className="menu-text"> Projekte</span>
            </NavLink>
          </li>
          <li
            className={`menu-item ${getMenuItemActive("/funnel2", false)}`}
            aria-haspopup="true"
          >
            <NavLink className="menu-link" to="/funnel2">
              <span className="svg-icon menu-icon">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M19 3H18C16.8954 3 16 3.89543 16 5V19C16 20.1046 16.8954 21 18 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3Z"
                    fill="#B5B5C3"
                  />
                  <path
                    d="M12.5 9H11.5C10.3954 9 9.5 9.89543 9.5 11V19C9.5 20.1046 10.3954 21 11.5 21H12.5C13.6046 21 14.5 20.1046 14.5 19V11C14.5 9.89543 13.6046 9 12.5 9Z"
                    fill="#B5B5C3"
                  />
                  <path
                    d="M6 16H5C3.89543 16 3 16.8954 3 18V19C3 20.1046 3.89543 21 5 21H6C7.10457 21 8 20.1046 8 19V18C8 16.8954 7.10457 16 6 16Z"
                    fill="#B5B5C3"
                  />
                </svg>
              </span>
              <span className="menu-text" aria-hidden="true">
                Google Ads & Vergleich
              </span>
            </NavLink>
          </li>

          <li
            className={`menu-item ${getMenuItemActive("/anfrange", false)}`}
            aria-haspopup="true"
          >
            <NavLink className="menu-link" to="/anfrange">
              <span className="svg-icon menu-icon">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M5.85 11C6.89797 11 7.75 10.1031 7.75 9C7.75 7.89687 6.89797 7 5.85 7C4.80203 7 3.95 7.89687 3.95 9C3.95 10.1031 4.80203 11 5.85 11ZM19.15 11C20.198 11 21.05 10.1031 21.05 9C21.05 7.89687 20.198 7 19.15 7C18.102 7 17.25 7.89687 17.25 9C17.25 10.1031 18.102 11 19.15 11ZM20.1 12H18.2C17.6775 12 17.2055 12.2219 16.8611 12.5813C18.0575 13.2719 18.9066 14.5188 19.0906 16H21.05C21.5755 16 22 15.5531 22 15V14C22 12.8969 21.148 12 20.1 12ZM12.5 12C14.3377 12 15.825 10.4344 15.825 8.5C15.825 6.56562 14.3377 5 12.5 5C10.6623 5 9.175 6.56562 9.175 8.5C9.175 10.4344 10.6623 12 12.5 12ZM14.78 13H14.5336C13.9161 13.3125 13.2303 13.5 12.5 13.5C11.7697 13.5 11.0869 13.3125 10.4664 13H10.22C8.33187 13 6.8 14.6125 6.8 16.6V17.5C6.8 18.3281 7.43828 19 8.225 19H16.775C17.5617 19 18.2 18.3281 18.2 17.5V16.6C18.2 14.6125 16.6681 13 14.78 13ZM8.13891 12.5813C7.79453 12.2219 7.3225 12 6.8 12H4.9C3.85203 12 3 12.8969 3 14V15C3 15.5531 3.42453 16 3.95 16H5.90641C6.09344 14.5188 6.9425 13.2719 8.13891 12.5813Z"
                    fill="#B5B5C3"
                  />
                </svg>
              </span>
              <span className="menu-text">Anfrage (Website)</span>
            </NavLink>
          </li>

          <li
            className={`menu-item  ${getMenuItemActive("/news", false)}`}
            aria-haspopup="true"
          >
            <NavLink className="menu-link " to="/news">
              <span className="svg-icon menu-icon">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M5.99709 14.4016V12.0016H8.39709V14.4016H5.99709ZM17.9971 5.39436C17.9952 4.91822 17.8047 4.46223 17.4673 4.12622C17.13 3.79021 16.6732 3.60156 16.1971 3.60156H4.10469C3.6273 3.60156 3.16946 3.7912 2.8319 4.12877C2.49433 4.46634 2.30469 4.92417 2.30469 5.40156V16.2016C2.30469 16.9972 2.62076 17.7603 3.18337 18.3229C3.74598 18.8855 4.50904 19.2016 5.30469 19.2016H18.6895C19.4851 19.2016 20.2482 18.8855 20.8108 18.3229C21.3734 17.7603 21.6895 16.9972 21.6895 16.2016V9.00156C21.6895 8.52417 21.4998 8.06634 21.1623 7.72877C20.8247 7.3912 20.3669 7.20156 19.8895 7.20156H19.1971V15.8776C19.1971 16.0367 19.1339 16.1893 19.0214 16.3018C18.9088 16.4143 18.7562 16.4776 18.5971 16.4776C18.438 16.4776 18.2853 16.4143 18.1728 16.3018C18.0603 16.1893 17.9971 16.0367 17.9971 15.8776V5.39436ZM4.79709 7.80156C4.79709 7.64243 4.8603 7.48982 4.97282 7.3773C5.08535 7.26478 5.23796 7.20156 5.39709 7.20156H14.9971C15.1562 7.20156 15.3088 7.26478 15.4214 7.3773C15.5339 7.48982 15.5971 7.64243 15.5971 7.80156C15.5971 7.96069 15.5339 8.1133 15.4214 8.22583C15.3088 8.33835 15.1562 8.40156 14.9971 8.40156H5.39709C5.23796 8.40156 5.08535 8.33835 4.97282 8.22583C4.8603 8.1133 4.79709 7.96069 4.79709 7.80156ZM11.3971 10.8016H14.9971C15.1562 10.8016 15.3088 10.8648 15.4214 10.9773C15.5339 11.0898 15.5971 11.2424 15.5971 11.4016C15.5971 11.5607 15.5339 11.7133 15.4214 11.8258C15.3088 11.9383 15.1562 12.0016 14.9971 12.0016H11.3971C11.238 12.0016 11.0853 11.9383 10.9728 11.8258C10.8603 11.7133 10.7971 11.5607 10.7971 11.4016C10.7971 11.2424 10.8603 11.0898 10.9728 10.9773C11.0853 10.8648 11.238 10.8016 11.3971 10.8016ZM10.7971 15.0016C10.7971 14.8424 10.8603 14.6898 10.9728 14.5773C11.0853 14.4648 11.238 14.4016 11.3971 14.4016H14.9971C15.1562 14.4016 15.3088 14.4648 15.4214 14.5773C15.5339 14.6898 15.5971 14.8424 15.5971 15.0016C15.5971 15.1607 15.5339 15.3133 15.4214 15.4258C15.3088 15.5383 15.1562 15.6016 14.9971 15.6016H11.3971C11.238 15.6016 11.0853 15.5383 10.9728 15.4258C10.8603 15.3133 10.7971 15.1607 10.7971 15.0016ZM5.39709 10.8016H8.99709C9.15622 10.8016 9.30883 10.8648 9.42135 10.9773C9.53387 11.0898 9.59709 11.2424 9.59709 11.4016V15.0016C9.59709 15.1607 9.53387 15.3133 9.42135 15.4258C9.30883 15.5383 9.15622 15.6016 8.99709 15.6016H5.39709C5.23796 15.6016 5.08535 15.5383 4.97282 15.4258C4.8603 15.3133 4.79709 15.1607 4.79709 15.0016V11.4016C4.79709 11.2424 4.8603 11.0898 4.97282 10.9773C5.08535 10.8648 5.23796 10.8016 5.39709 10.8016Z"
                    fill="#B5B5C3"
                  />
                </svg>
              </span>
              <span className="menu-text">Newsletter (Website)</span>
            </NavLink>
          </li>

          <li
            className={`menu-item  ${getMenuItemActive("/kontakt", false)}`}
            aria-haspopup="true"
          >
            <NavLink className="menu-link " to="/kontakt">
              <span className="svg-icon menu-icon">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M19.2 4H7.2C6.77565 4 6.36869 4.16857 6.06863 4.46863C5.76857 4.76869 5.6 5.17565 5.6 5.6V8H4V9.6H5.6V11.2H4V12.8H5.6V14.4H4V16H5.6V18.4C5.6 18.8243 5.76857 19.2313 6.06863 19.5314C6.36869 19.8314 6.77565 20 7.2 20H19.2C19.4122 20 19.6157 19.9157 19.7657 19.7657C19.9157 19.6157 20 19.4122 20 19.2V4.8C20 4.58783 19.9157 4.38434 19.7657 4.23431C19.6157 4.08429 19.4122 4 19.2 4ZM12.8 6.3992C14.1184 6.3992 15.2 7.48 15.2 8.7992C15.1977 9.43508 14.9441 10.0443 14.4945 10.494C14.045 10.9437 13.4359 11.1975 12.8 11.2C11.4824 11.2 10.4 10.1176 10.4 8.7992C10.4 7.48 11.4824 6.3992 12.8 6.3992ZM17.6 16.8H8V16.2C8 14.4248 10.164 12.6 12.8 12.6C15.436 12.6 17.6 14.4248 17.6 16.2V16.8Z"
                    fill="#B5B5C3"
                  />
                </svg>
              </span>
              <span className="menu-text">Kontakt (Website)</span>
            </NavLink>
          </li> */}
        </ul>
      )}

      {/* {userInfo?.role === "vattenfallAdmin" && (
        <ul className={`menu-nav ${layoutProps.ulClasses}`} ref={ref}>

<li
            className={`menu-item ${getMenuItemActive("/dashboard", false)}`}
            aria-haspopup="true"
          >
            <NavLink className="menu-link" to="/dashboard">
              <span className="svg-icon menu-icon">
                <svg
                  width="24"
                  height="20"
                  viewBox="0 0 24 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M19.9545 3.54469C17.8846 1.48711 15.096 0.314504 12.1777 0.274496C9.25932 0.234487 6.43965 1.33021 4.31407 3.33027C2.18849 5.33034 0.923398 8.07819 0.785934 10.9936C0.648469 13.909 1.64939 16.7637 3.57735 18.9548L3.58579 18.9642C3.60125 18.9806 3.61579 18.9975 3.63266 19.0134C3.66735 19.0528 3.70672 19.0974 3.75313 19.1438C3.93512 19.3372 4.15508 19.491 4.39925 19.5955C4.64341 19.7 4.90652 19.753 5.17211 19.7512C5.4377 19.7493 5.70005 19.6927 5.94273 19.5848C6.18542 19.4769 6.40322 19.32 6.5825 19.1241C7.27234 18.3743 8.11022 17.7759 9.04317 17.3665C9.97612 16.9571 10.9839 16.7458 12.0027 16.7458C13.0215 16.7458 14.0292 16.9571 14.9622 17.3665C15.8951 17.7759 16.733 18.3743 17.4228 19.1241C17.6034 19.3211 17.823 19.4784 18.0676 19.5861C18.3121 19.6938 18.5764 19.7496 18.8437 19.7498C19.1109 19.7501 19.3753 19.6949 19.6201 19.5876C19.8649 19.4804 20.0848 19.3235 20.2658 19.1269L20.4163 18.9628L20.4247 18.9534C22.3243 16.8084 23.3336 14.0191 23.2465 11.1552C23.1594 8.2912 21.9824 5.56847 19.9559 3.54282L19.9545 3.54469ZM11.2498 4.00173C11.2498 3.80281 11.3289 3.61205 11.4695 3.4714C11.6102 3.33074 11.8009 3.25173 11.9998 3.25173C12.1988 3.25173 12.3895 3.33074 12.5302 3.4714C12.6708 3.61205 12.7498 3.80281 12.7498 4.00173V5.50173C12.7498 5.70064 12.6708 5.8914 12.5302 6.03205C12.3895 6.17271 12.1988 6.25173 11.9998 6.25173C11.8009 6.25173 11.6102 6.17271 11.4695 6.03205C11.3289 5.8914 11.2498 5.70064 11.2498 5.50173V4.00173ZM5.99985 12.2517H4.49985C4.30094 12.2517 4.11017 12.1727 3.96952 12.0321C3.82887 11.8914 3.74985 11.7006 3.74985 11.5017C3.74985 11.3028 3.82887 11.112 3.96952 10.9714C4.11017 10.8307 4.30094 10.7517 4.49985 10.7517H5.99985C6.19876 10.7517 6.38953 10.8307 6.53018 10.9714C6.67083 11.112 6.74985 11.3028 6.74985 11.5017C6.74985 11.7006 6.67083 11.8914 6.53018 12.0321C6.38953 12.1727 6.19876 12.2517 5.99985 12.2517ZM8.28735 7.78923C8.14671 7.92977 7.95602 8.00872 7.75719 8.00872C7.55836 8.00872 7.36767 7.92977 7.22703 7.78923L6.16625 6.72891C6.02559 6.58824 5.94656 6.39746 5.94656 6.19852C5.94656 5.99959 6.02559 5.8088 6.16625 5.66813C6.30692 5.52746 6.49771 5.44844 6.69664 5.44844C6.89558 5.44844 7.08637 5.52746 7.22703 5.66813L8.28735 6.72891C8.42789 6.86955 8.50684 7.06024 8.50684 7.25907C8.50684 7.4579 8.42789 7.64859 8.28735 7.78923ZM15.2858 8.87204L13.0592 12.4111C12.9681 12.5373 12.8573 12.6481 12.7311 12.7392C12.4263 12.9518 12.05 13.0357 11.6838 12.9726C11.3176 12.9094 10.991 12.7044 10.775 12.402C10.5591 12.0996 10.471 11.7243 10.5301 11.3574C10.5891 10.9905 10.7905 10.6617 11.0905 10.4424L14.6295 8.21579C14.71 8.15971 14.8057 8.12964 14.9038 8.12964C15.0018 8.12964 15.0975 8.15971 15.178 8.21579C15.279 8.28873 15.3471 8.3987 15.3673 8.52167C15.3875 8.64464 15.3582 8.7706 15.2858 8.87204ZM16.7727 7.78923C16.6309 7.92394 16.4421 7.99793 16.2465 7.99543C16.0509 7.99293 15.8641 7.91412 15.7258 7.77582C15.5875 7.63752 15.5086 7.45066 15.5061 7.25509C15.5036 7.05952 15.5776 6.87071 15.7123 6.72891L16.7727 5.66813C16.9133 5.52746 17.1041 5.44844 17.3031 5.44844C17.502 5.44844 17.6928 5.52746 17.8334 5.66813C17.9741 5.8088 18.0531 5.99959 18.0531 6.19852C18.0531 6.39746 17.9741 6.58824 17.8334 6.72891L16.7727 7.78923ZM19.4998 12.2517H17.9998C17.8009 12.2517 17.6102 12.1727 17.4695 12.0321C17.3289 11.8914 17.2498 11.7006 17.2498 11.5017C17.2498 11.3028 17.3289 11.112 17.4695 10.9714C17.6102 10.8307 17.8009 10.7517 17.9998 10.7517H19.4998C19.6988 10.7517 19.8895 10.8307 20.0302 10.9714C20.1708 11.112 20.2498 11.3028 20.2498 11.5017C20.2498 11.7006 20.1708 11.8914 20.0302 12.0321C19.8895 12.1727 19.6988 12.2517 19.4998 12.2517Z"
                    fill="#B5B5C3"
                  />
                </svg>
              </span>
              <span className="menu-text">Dashboard</span>
            </NavLink>
          </li>
          <li
            className={`menu-item ${getMenuItemActive("/vattenfall", false)}`}
            onMouseEnter={() => setId(2)}
            onMouseLeave={() => setId("")}
            aria-haspopup="true"
          >
            <NavLink className="menu-link" to="/vattenfall">
              <span className="svg-icon menu-icon">
                {getMenuItemActive("/vattenfall") || id == "2" ? (
                  <svg
                    width="228"
                    height="230"
                    viewBox="0 0 228 230"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M113.689 0C50.9003 0 0 51.4871 0 115H227.379C227.379 51.4871 176.478 0 113.689 0Z"
                      fill="#F7D307"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M113.689 230C50.9003 230 0 178.513 0 115H227.379C227.379 178.513 176.478 230 113.689 230Z"
                      fill="#1E6EB0"
                    />
                  </svg>
                ) : (
                  <svg
                    width="74"
                    height="75"
                    viewBox="0 0 74 75"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M37 0C16.5654 0 0 17.0131 0 38H74C74 17.0131 57.4346 0 37 0Z"
                      fill="#DBDBE9"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M37 75C16.5654 75 0 58.4346 0 38H74C74 58.4346 57.4346 75 37 75Z"
                      fill="#B5B5C3"
                    />
                  </svg>
                )}
              </span>
              <span className="menu-text">Vattenfall Leads</span>
            </NavLink>
          </li>

          <li
            className={`menu-item ${getMenuItemActive(
              "/vattenfallmesse",
              false
            )}`}
            onMouseEnter={() => setId(20)}
            onMouseLeave={() => setId("")}
            aria-haspopup="true"
          >
            <NavLink className="menu-link" to="/vattenfallmesse">
              <span className="svg-icon menu-icon">
                {getMenuItemActive("/vattenfallmesse") || id == "20" ? (
                  <svg
                    width="228"
                    height="230"
                    viewBox="0 0 228 230"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M113.689 0C50.9003 0 0 51.4871 0 115H227.379C227.379 51.4871 176.478 0 113.689 0Z"
                      fill="#F7D307"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M113.689 230C50.9003 230 0 178.513 0 115H227.379C227.379 178.513 176.478 230 113.689 230Z"
                      fill="#1E6EB0"
                    />
                  </svg>
                ) : (
                  <svg
                    width="74"
                    height="75"
                    viewBox="0 0 74 75"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M37 0C16.5654 0 0 17.0131 0 38H74C74 17.0131 57.4346 0 37 0Z"
                      fill="#DBDBE9"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M37 75C16.5654 75 0 58.4346 0 38H74C74 58.4346 57.4346 75 37 75Z"
                      fill="#B5B5C3"
                    />
                  </svg>
                )}
              </span>
              <span className="menu-text">Vattenfall Messe Leads</span>
            </NavLink>
          </li>

          <li
            className={`menu-item ${getMenuItemActive(
              "/vattenfallpromo",
              false
            )}`}
            onMouseEnter={() => setId(56)}
            onMouseLeave={() => setId("")}
            aria-haspopup="true"
          >
            <NavLink className="menu-link" to="/vattenfallpromo">
              <span className="svg-icon menu-icon">
                {getMenuItemActive("/vattenfallpromo") || id == "56" ? (
                  <svg
                    width="228"
                    height="230"
                    viewBox="0 0 228 230"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M113.689 0C50.9003 0 0 51.4871 0 115H227.379C227.379 51.4871 176.478 0 113.689 0Z"
                      fill="#F7D307"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M113.689 230C50.9003 230 0 178.513 0 115H227.379C227.379 178.513 176.478 230 113.689 230Z"
                      fill="#1E6EB0"
                    />
                  </svg>
                ) : (
                  <svg
                    width="74"
                    height="75"
                    viewBox="0 0 74 75"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M37 0C16.5654 0 0 17.0131 0 38H74C74 17.0131 57.4346 0 37 0Z"
                      fill="#DBDBE9"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M37 75C16.5654 75 0 58.4346 0 38H74C74 58.4346 57.4346 75 37 75Z"
                      fill="#B5B5C3"
                    />
                  </svg>
                )}
              </span>
              <span className="menu-text">Vattenfall Promo Funnel</span>
            </NavLink>
          </li>
        </ul>
      )} */}
    </>
  );
}
